module.exports = __webpack_public_path__ + "static/media/relax.c622bcaa.svg";